export const CHAT_STATUS_GENERAL = {
  PROCESSING: [0, 1, 2, 3],
  COMPLETED: 4,
  ERROR: 5,
  PENDING: 0,
  IN_PROGRESS: [1, 2],
  NEAR_COMPLETE: 3,
};

export const DRAWING_ANALYSIS_CHAT_STATUS = {
  PROCESSING: [0, 1, 2, 3, 4],
  COMPLETED: 5,
  ERROR: 6,
  PENDING: 0,
  IN_PROGRESS: [1, 2, 3],
  NEAR_COMPLETE: 4,
};
